import { render, staticRenderFns } from "./GreenEnergyAdd.vue?vue&type=template&id=067730c7&scoped=true"
import script from "./GreenEnergyAdd.vue?vue&type=script&lang=js"
export * from "./GreenEnergyAdd.vue?vue&type=script&lang=js"
import style0 from "./GreenEnergyAdd.vue?vue&type=style&index=0&id=067730c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067730c7",
  null
  
)

export default component.exports